import { EventV2 } from '@/services/EventService/abstract/EventV2';

export default class ClaimSetCreatedEvent extends EventV2<string> {}
